import React from 'react';

const SelectedDivisions = ({ divisions, delDivision }) => {

    return (
        divisions.map((i, ix) =>
            <div className="row" key={ix}>
                <div className="col-md-12">
                    <button className="btn btn-light" onClick={() => delDivision(i.divisionId)}>{i.title}</button>
                </div>
            </div>
        )
    );
}

export default SelectedDivisions;